<template>
    <section id="project_two_content">

        <div class="row" id="first_row">

            <!-- In Small Screen -->
            <h3 class="mt-4 mb-0 d-block d-lg-none">دوري FIRST</h3>

            <div class="col-12 col-lg-6 mt-3 mt-lg-4 order-2 order-lg-1">

                <div class="col_one_content d-flex flex-column justify-content-start w-100 h-100">

                    <h3 class="d-none d-lg-block">دوري FIRST</h3>

                    <p>الشريك المنظم لدوري فيرست وهي منظمة عالمية هدفها الهام الشباب ليصبحو قادة ومخترعي العلوم و التقنية من
                        خلال إشراكهم في البرامج المثيرة والتجريبية والموجهة والمشاريع التي تقوم بتدريس مهارات العلوم
                        والتكنولوجيا والهندسة والرياضيات والإلهام للابتكار وتعزيز القدرات الحياتية.</p>

                    <div class="logo_wrapper mt-3">
                        <img src="@/assets/images/projects/FIRST.webp" alt="">
                    </div>

                    <h5 class="mt-3">موسم 2023</h5>

                    <p>تلهمنا مبادئ العلوم والتكنولوجيا والهندسة والفن والرياضيات (STEAM) الأفكار الإبداعية العظيمة والعمل
                        الفني. 
                        هدفنا في هذا الموسم هو إلهام الشباب لاستخدام مهاراتهم في البرمجة والتركيب والروبوتات لوصل العالم
                        بالفن ولتمكين الشباب من خلق عوالم لا نهائية من المزيج بين التكنولوجيا والفنون.</p>

                </div>

            </div>

            <div class="col-12 col-lg-6 mt-3 mt-lg-4 d-flex justify-content-center align-items-start order-1 order-lg-2">

                <div class="col_two_content">
                    <div class="img_wrapper">
                        <img src="@/assets/images/projects/project_two_img.webp" alt="">
                    </div>
                </div>

            </div>

        </div>

        <div class="row mb-3 mb-lg-0 d-flex justify-content-center" id="second_row">

            <h5 class="mt-3 mb-0">تعرف على فئات البطولة</h5>

            <div class="mt-3 my_col">

                <div class="col_three_content w-100 h-100">

                    <!-- <router-link :to="{ name: '' }"> -->
                        <div class="card p-3">
                            <div class="image_wrapper">
                                <img class="card-img-top" src="@/assets/images/projects/first1.webp" alt="" />
                            </div>
                            <div class="card-body">
                                <h5 class="card-title text-center">دوري فيرست ليجو (الصغار)<br />2023-2024</h5>
                            </div>
                        </div>
                    <!-- </router-link> -->

                </div>

            </div>

            <div class="mt-3 my_col">

                <div class="col_three_content w-100 h-100">

                    <!-- <router-link :to="{ name: '' }"> -->
                        <div class="card p-3">
                            <div class="image_wrapper">
                                <img class="card-img-top" src="@/assets/images/projects/first2.webp" alt="" />
                            </div>
                            <div class="card-body">
                                <h5 class="card-title text-center">دوري فيرست ليجو (التحدي)<br />2023-2024</h5>
                            </div>
                        </div>
                    <!-- </router-link> -->

                </div>

            </div>

            <div class="mt-3 my_col">

                <div class="col_three_content w-100 h-100">

                    <!-- <router-link :to="{ name: '' }"> -->
                        <div class="card p-3">
                            <div class="image_wrapper">
                                <img class="card-img-top" src="@/assets/images/projects/first3.webp" alt="" />
                            </div>
                            <div class="card-body">
                                <h5 class="card-title text-center">تحدي فيرست التقني<br />2023-2024</h5>
                            </div>
                        </div>
                    <!-- </router-link> -->

                </div>

            </div>

        </div>

    </section>
</template>

<script>
export default {
    name: 'ProjectTwo',
}
</script>

<style lang="scss" scoped>
#project_two_content {

    #first_row {

        h3 {
            font-family: 'FFShamelFamily-Bold';
            color: $Green;
            font-size: 18px;
            line-height: 180%;
        }

        .col_one_content {

            p {
                color: $White;
                font-size: 16px;
                line-height: 180%;
                text-align: justify;
                margin-bottom: 0;
            }

            .logo_wrapper {
                width: 137px;
                height: 40px;

                img {
                    width: 100%;
                    height: 100%;
                    object-fit: cover;
                }
            }

            h5 {
                font-family: 'FFShamelFamily-Bold';
                font-size: 16px;
                line-height: 156%;
                color: $Green;
            }

        }

        // https://stackoverflow.com/questions/31854185/how-to-add-border-in-my-clip-path-polygon-css-style
        .col_two_content {

            position: relative;

            width: 636px;
            height: 426px;

            @include breakpoints(x-small) {
                width: 351px;
                height: 235px;
            }

            @include breakpoints(small) {
                width: 516px;
                height: 345px;
            }

            @include breakpoints(medium) {
                width: 696px;
                height: 466px;
            }

            @include breakpoints(large) {
                width: 456px;
                height: 305px;
            }

            @include breakpoints(x-Large) {
                width: 546px;
                height: 366px;
            }

            background: $Green;
            box-sizing: border-box;

            // https://www.cssportal.com/css-clip-path-generator/
            // CSS Vendor Prefixes
            -webkit-clip-path: polygon(0% 3%, 0% 3%, 3% 0%, 3% 0%, 97% 0%, 97% 0%, 100% 3%, 100% 3%, 100% 80%, 100% 80%, 97% 85%, 97% 85%, 90% 85%, 90% 85%, 77% 100%, 77% 100%, 3% 100%, 3% 100%, 0% 97%, 0% 97%);
            -moz-clip-path: polygon(0% 3%, 0% 3%, 3% 0%, 3% 0%, 97% 0%, 97% 0%, 100% 3%, 100% 3%, 100% 80%, 100% 80%, 97% 85%, 97% 85%, 90% 85%, 90% 85%, 77% 100%, 77% 100%, 3% 100%, 3% 100%, 0% 97%, 0% 97%);
            -o-clip-path: polygon(0% 3%, 0% 3%, 3% 0%, 3% 0%, 97% 0%, 97% 0%, 100% 3%, 100% 3%, 100% 80%, 100% 80%, 97% 85%, 97% 85%, 90% 85%, 90% 85%, 77% 100%, 77% 100%, 3% 100%, 3% 100%, 0% 97%, 0% 97%);
            -ms-clip-path: polygon(0% 3%, 0% 3%, 3% 0%, 3% 0%, 97% 0%, 97% 0%, 100% 3%, 100% 3%, 100% 80%, 100% 80%, 97% 85%, 97% 85%, 90% 85%, 90% 85%, 77% 100%, 77% 100%, 3% 100%, 3% 100%, 0% 97%, 0% 97%);
            clip-path: polygon(0% 3%, 0% 3%, 3% 0%, 3% 0%, 97% 0%, 97% 0%, 100% 3%, 100% 3%, 100% 80%, 100% 80%, 97% 85%, 97% 85%, 90% 85%, 90% 85%, 77% 100%, 77% 100%, 3% 100%, 3% 100%, 0% 97%, 0% 97%);

            .img_wrapper {

                position: absolute;
                top: 1px;
                left: 1px;

                width: 634px;
                height: 424px;

                @include breakpoints(x-small) {
                    width: 349px;
                    height: 233px;
                }

                @include breakpoints(small) {
                    width: 514px;
                    height: 343px;
                }

                @include breakpoints(medium) {
                    width: 694px;
                    height: 464px;
                }

                @include breakpoints(large) {
                    width: 454px;
                    height: 303px;
                }

                @include breakpoints(x-Large) {
                    width: 544px;
                    height: 364px;
                }

                // https://www.cssportal.com/css-clip-path-generator/
                // CSS Vendor Prefixes
                -webkit-clip-path: polygon(0% 3%, 0% 3%, 3% 0%, 3% 0%, 97% 0%, 97% 0%, 100% 3%, 100% 3%, 100% 80%, 100% 80%, 97% 85%, 97% 85%, 90% 85%, 90% 85%, 77% 100%, 77% 100%, 3% 100%, 3% 100%, 0% 97%, 0% 97%);
                -moz-clip-path: polygon(0% 3%, 0% 3%, 3% 0%, 3% 0%, 97% 0%, 97% 0%, 100% 3%, 100% 3%, 100% 80%, 100% 80%, 97% 85%, 97% 85%, 90% 85%, 90% 85%, 77% 100%, 77% 100%, 3% 100%, 3% 100%, 0% 97%, 0% 97%);
                -o-clip-path: polygon(0% 3%, 0% 3%, 3% 0%, 3% 0%, 97% 0%, 97% 0%, 100% 3%, 100% 3%, 100% 80%, 100% 80%, 97% 85%, 97% 85%, 90% 85%, 90% 85%, 77% 100%, 77% 100%, 3% 100%, 3% 100%, 0% 97%, 0% 97%);
                -ms-clip-path: polygon(0% 3%, 0% 3%, 3% 0%, 3% 0%, 97% 0%, 97% 0%, 100% 3%, 100% 3%, 100% 80%, 100% 80%, 97% 85%, 97% 85%, 90% 85%, 90% 85%, 77% 100%, 77% 100%, 3% 100%, 3% 100%, 0% 97%, 0% 97%);
                clip-path: polygon(0% 3%, 0% 3%, 3% 0%, 3% 0%, 97% 0%, 97% 0%, 100% 3%, 100% 3%, 100% 80%, 100% 80%, 97% 85%, 97% 85%, 90% 85%, 90% 85%, 77% 100%, 77% 100%, 3% 100%, 3% 100%, 0% 97%, 0% 97%);

                // border: solid 2px $Green;

                img {
                    width: 100%;
                    height: 100%;
                    object-fit: cover;
                    opacity: 0.9;
                }

                img:hover {
                    opacity: 1;
                    -webkit-transition: opacity 0.5s linear 0.2s;
                    -moz-transition: opacity 0.5s linear 0.2s;
                    transition: opacity 0.5s linear 0.2s;
                }

            }

        }

    }

    #second_row {

        h5 {

            font-family: 'FFShamelFamily-Bold';
            font-size: 16px;
            line-height: 156%;
            color: $Yellow;
        }

        .my_col {

            width: calc(100% / 3);

            @include breakpoints(x-small) {
                width: calc(100% / 2);
            }

            @include breakpoints(small) {
                width: calc(100% / 2);
            }

            .col_three_content {

                .card {

                    background: $Dark-Green;

                    // CSS Vendor Prefixes
                    -webkit-clip-path: polygon(0% 3%, 0% 3%, 0% 80%, 0% 80%, 3% 85%, 3% 85%, 10% 85%, 10% 85%, 23% 100%, 23% 100%, 97% 100%, 97% 100%, 100% 97%, 100% 97%, 100% 3%, 100% 3%, 97% 0%, 97% 0%, 3% 0%, 3% 0%);
                    -moz-clip-path: polygon(0% 3%, 0% 3%, 0% 80%, 0% 80%, 3% 85%, 3% 85%, 10% 85%, 10% 85%, 23% 100%, 23% 100%, 97% 100%, 97% 100%, 100% 97%, 100% 97%, 100% 3%, 100% 3%, 97% 0%, 97% 0%, 3% 0%, 3% 0%);
                    -o-clip-path: polygon(0% 3%, 0% 3%, 0% 80%, 0% 80%, 3% 85%, 3% 85%, 10% 85%, 10% 85%, 23% 100%, 23% 100%, 97% 100%, 97% 100%, 100% 97%, 100% 97%, 100% 3%, 100% 3%, 97% 0%, 97% 0%, 3% 0%, 3% 0%);
                    -ms-clip-path: polygon(0% 3%, 0% 3%, 0% 80%, 0% 80%, 3% 85%, 3% 85%, 10% 85%, 10% 85%, 23% 100%, 23% 100%, 97% 100%, 97% 100%, 100% 97%, 100% 97%, 100% 3%, 100% 3%, 97% 0%, 97% 0%, 3% 0%, 3% 0%);
                    clip-path: polygon(0% 3%, 0% 3%, 0% 80%, 0% 80%, 3% 85%, 3% 85%, 10% 85%, 10% 85%, 23% 100%, 23% 100%, 97% 100%, 97% 100%, 100% 97%, 100% 97%, 100% 3%, 100% 3%, 97% 0%, 97% 0%, 3% 0%, 3% 0%);

                    height: 200px;

                    @include breakpoints(x-small) {
                        height: 230px;
                    }

                    @include breakpoints(small) {
                        height: 230px;
                    }

                    @include breakpoints(medium) {
                        height: 220px;
                    }

                    .image_wrapper {
                        width: 60%;
                        height: 80px;
                        margin: auto;

                        img {
                            width: 100%;
                            height: 100%;
                            object-fit: contain;
                        }
                    }

                    .card-body {

                        h5 {
                            font-family: 'FFShamelFamily-Bold';
                            font-size: 16px;
                            line-height: 156%;
                            color: $White;
                        }

                    }

                }

                .card:hover {
                    background: $Linear-Blue;
                }

            }

        }

    }

}
</style>